<div *ngIf="session && !session.is_completed" class="img-bg">
  <img src="/assets/bg-session-pre.jpg" />
</div>
<div class="container">
  <div
    class="d-flex justify-content-between align-items-center mb-4"
    style="max-width: 1215px">
    <div class="col-9">
      <div class="fs-17 fw-800">
        <a href="/training/catalog" style="color: #000"
          >< Back to Learning &amp; Events</a
        >
      </div>
    </div>
    <div class="col-3 col-md-auto">
      <app-action-buttons />
    </div>
  </div>
  <div class="card session-details-card border-0">
    <ng-container *ngIf="!forbidden; else deniedMessage">
      <ng-container *ngIf="session; else loadingTemplate">
        <div class="d-flex justify-content-end mb-3">
          <div *ngIf="(isFacilitator || isCreator) && !session.is_completed">
            <button
              class="btn-reset fw-600 fs-16 ms-4"
              style="white-space: nowrap"
              (click)="editSessionModal.modal.open()">
              <i class="bi bi-pencil color-tertiary fs-12 me-1"></i> Edit
              Session Details
            </button>
            <app-edit-microlearning-session-modal
              [session]="session"
              (sessionUpdated)="updateSession($event)"
              (sessionDeleted)="navigateToCatalog()"
              #editSessionModal></app-edit-microlearning-session-modal>
            <button
              *ngIf="session && session.quiz_proform_form_id"
              class="btn-reset fw-600 fs-16 ms-4"
              style="white-space: nowrap"
              (click)="editQuizModal.open()">
              <i class="bi bi-pencil color-tertiary fs-12 me-1"></i> Edit
              Session Quiz
            </button>
            <app-modal
              #editQuizModal
              [modalConfig]="{
                headerClass: ['modal-header', 'bg-primary', 'text-white'],
                options: { size: 'xl' },
                titleText: 'Edit Session Quiz',
                showFooter: false
              }">
              <button
                class="bg-transparent border-0"
                title="Close"
                aria-label="close"
                headerContent
                (click)="editQuizModal.close()">
                <i class="bi bi-x-lg text-white"></i>
              </button>
              <div
                class="px-5 py-4"
                *ngIf="session && session.quiz_proform_form_id">
                <app-microlearning-quiz-builder
                  [formId]="session.quiz_proform_form_id" />
              </div>
            </app-modal>
          </div>
        </div>
        <div class="date-tab">
          <div class="date-box justify-content-center align-items-center">
            <div class="month fw-800">
              {{ session.start_datetime * 1000 | date : "MMM" | uppercase }}
            </div>
            <div class="day fw-800">
              {{ session.start_datetime * 1000 | date : "dd" }}
            </div>
          </div>
          <div class="vert-div"></div>
        </div>

        <div class="header-content">
          <div class="title fs-26 fw-800 mb-3">
            {{ session.title }}
          </div>
        </div>

        <div class="session-data">
          <!--///////////////////////////////////////////// -->
          <!-- CONTENT  /////////////////////////////////// -->
          <!--///////////////////////////////////////////// -->
          <div class="content">
            <div class="d-flex justify-content-start mb-5">
              <div
                class="session-image me-4"
                [ngStyle]="{
                  'background-image': backgroundImage
                }"></div>
              <div class="session-desc">
                {{ session.description }}
              </div>
            </div>

            <!--///////////////////////////////////////////// -->
            <!--NOTES /////////////////////////////////////// -->
            <!--///////////////////////////////////////////// -->
            <div
              *ngIf="isRegistered || isFacilitator"
              class="mb-5"
              style="word-break: break-all">
              <ng-container *ngIf="!isFacilitator; else editNotes">
                <div>
                  <app-safehtml html="{{ session.notes }}"></app-safehtml>
                </div>
              </ng-container>
              <ng-template #editNotes>
                <div class="w-100" style="word-break: break-all">
                  <app-ck-editor
                    #notesEditor
                    [initialData]="initialNotesContent"
                    (contentChange)="updateNotes($event)"
                    [version]="'full'">
                  </app-ck-editor>
                </div>
              </ng-template>
            </div>

            <!--///////////////////////////////////////////// -->
            <!--ACTION LIST ///////////////////////////////// -->
            <!--///////////////////////////////////////////// -->
            <div *ngIf="!isFacilitator && isRegistered" class="mb-5 mb-xl-0">
              <app-microlearning-action-list
                [quizId]="session.quiz_proform_form_id"
                [surveyId]="session.survey_proform_form_id"
                [sessionId]="session.id"
                [courseId]="session.lms_course_id"
                [isReviewed]="session.is_completed === 1"
                [creditAwardingMethod]="session.credit_awarding_method"
                [creditsEarned]="
                  creditsReceived && creditsReceived.credits.length > 0
                "
                (quizPassed)="
                  session.credit_awarding_method ===
                  PdCreditAwardingMethod.QUIZ_PASSED
                    ? getSession(session.id)
                    : null
                "></app-microlearning-action-list>
            </div>
          </div>
          <div *ngIf="!isFacilitator" class="divider"></div>
          <!--///////////////////////////////////////////// -->
          <!-- SIDEBAR  /////////////////////////////////// -->
          <!--///////////////////////////////////////////// -->
          <div class="sidebar">
            <div class="sub-header"><span>DETAILS</span></div>
            <div class="item d-flex justify-content-between">
              <div class="label">Type:</div>
              {{ session.type }}
            </div>
            <div class="item d-flex justify-content-between">
              <div class="label">Credits:</div>
              <div *ngIf="session.credits && session.credits.length > 0">
                <ng-container *ngFor="let credit of session.credits">
                  <div class="credit-item">
                    <div class="amt">{{ credit.credit_amount }}</div>
                    <div class="type">{{ credit.credit_type }}</div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="item mb-5">
              <div class="label mb-2">
                Facilitator{{
                  session.facilitators && session.facilitators.length > 1
                    ? "s"
                    : ""
                }}:
              </div>
              <ng-container
                *ngIf="session.facilitators && session.facilitators.length > 0">
                <ng-container *ngFor="let facilitator of session.facilitators">
                  <div
                    class="d-flex justify-content-start align-items-center fs-14 mb-1">
                    <app-avatar
                      [hideTooltip]="true"
                      [profile]="facilitator.user.profile"
                      [avatarSize]="'small'"
                      [profileLinkActive]="true" />
                    <span class="ms-2">
                      {{ facilitator.user.profile.first_name }}
                      {{ facilitator.user.profile.last_name }}</span
                    >
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <ng-container *ngIf="isFacilitator">
              <ng-container *ngIf="session.lms_course_id">
                <div class="sub-header"><span>COURSE</span></div>
                <div class="d-flex justify-content-center">
                  <button
                    type="button"
                    class="btn btn-primary btn-register fw-800"
                    style="font-size: 18px"
                    (click)="previewCourse()">
                    PREVIEW COURSE
                  </button>
                </div>
              </ng-container>
              <ng-container *ngIf="session.quiz_proform_form_id">
                <div class="sub-header mt-5"><span>QUIZ</span></div>
                <div class="d-flex justify-content-center">
                  <button
                    type="button"
                    class="btn btn-primary btn-register fw-800"
                    style="font-size: 18px"
                    (click)="previewQuizModal.open()">
                    PREVIEW QUIZ
                  </button>
                </div>
                <div class="d-flex justify-content-center">
                  <button
                    type="button"
                    class="btn btn-primary btn-register fw-800 mt-3"
                    style="font-size: 18px"
                    (click)="quizResultsModal.open()">
                    VIEW QUIZ RESULTS
                  </button>
                </div>
              </ng-container>
            </ng-container>
            <div
              *ngIf="
                !isFacilitator &&
                !session.is_completed &&
                creditsReceived.credits.length === 0
              ">
              <div class="sub-header"><span>REGISTRATION</span></div>
              <div class="item d-flex justify-content-between">
                <div class="label">Registration Window:</div>
                <div class="text-end">
                  <div>
                    {{
                      session.registration_start_datetime
                        | formatDateOrdinal : "MMM d"
                    }},
                    {{
                      session.registration_start_datetime * 1000 | date : "yyyy"
                    }}
                    -
                  </div>
                  <div
                    *ngIf="
                      session.registration_end_datetime &&
                      session.registration_end_datetime !== null
                    ">
                    {{
                      session.registration_end_datetime
                        | formatDateOrdinal : "MMM d"
                    }},
                    {{
                      session.registration_end_datetime * 1000 | date : "yyyy"
                    }}
                  </div>
                </div>
              </div>
              <div class="item d-flex justify-content-between">
                <div class="label">Registered Users:</div>
                <div>{{ session.attendees.length }}</div>
              </div>
              <div class="mt-4 mb-5 text-center">
                <button
                  [disabled]="registerLoading"
                  *ngIf="!isRegistered && isInRegistrationWindow"
                  type="button "
                  class="btn btn-primary btn-register fw-800 mt-3"
                  style="font-size: 18px"
                  (click)="selfRegister(session.id)">
                  <span
                    *ngIf="registerLoading"
                    class="spinner-border spinner-border-sm me-1"></span>
                  Register
                </button>
                <button
                  *ngIf="isRegistered && !session.is_completed"
                  type="button"
                  class="btn btn-secondary btn-register fw-800 mt-3"
                  style="font-size: 18px; color: #fff"
                  (click)="unregisterUser(session.id, user.id)">
                  Cancel Registration
                </button>
              </div>
            </div>
            <ng-container
              *ngIf="creditsReceived && creditsReceived.credits.length > 0">
              <ng-container *ngIf="creditsReceived && selAttendeeId">
                <div class="sub-header"><span>CREDITS AWARDED</span></div>
                <div class="item">
                  <ng-container *ngFor="let credit of creditsReceived.credits"
                    ><div
                      *ngIf="credit.credit_type && credit.credit_value > 0"
                      class="d-flex justify-content-between align-items-center mb-3">
                      <div class="fs-13 fw-800">{{ credit.credit_type }}:</div>
                      <div class="fs-15 ms-2">
                        {{ credit.credit_value }}
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #nocredits>
                    No credits are available
                  </ng-template>
                </div>
                <div class="item text-center mb-5">
                  <a
                    href="{{ creditsReceived.certificate }}"
                    target="_blank"
                    class="fs-16">
                    <i class="bi-file-pdf"></i> Certificate of Completion
                  </a>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <!--///////////////////////////////////////////// -->
        <!--ATTENDEE MGMT //////////////////////////////// -->
        <!--///////////////////////////////////////////// -->
        <ng-container *ngIf="isFacilitator">
          <div class="attmgmt-header fs-26 fw-600">Attendee Management:</div>
          <!-- USER CREDIT FORM -->
          <form [formGroup]="usersCreditForm">
            <div class="table-wrapper">
              <table class="table attendee-table" style="min-width: 500px">
                <thead class="text-uppercase">
                  <tr class="text-center">
                    <th class="text-start">Attendee</th>
                    <th style="width: 100px">Present</th>
                    <th *ngIf="session.quiz">Quiz</th>
                    <th *ngIf="session.survey">Survey</th>
                    <th class="text-start">Credits</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
                    *ngIf="
                      usersCreditForm.value.users &&
                        usersCreditForm.value.users.length > 0;
                      else attmessage
                    ">
                    <ng-container formArrayName="users">
                      <ng-container
                        *ngFor="let user of users.controls; let i = index">
                        <tr [formGroupName]="i">
                          <td>
                            <div
                              [ngClass]="{
                                'not-present': !user.value.is_present
                              }"
                              class="d-flex align-items-center fs-16">
                              <app-avatar
                                [hideTooltip]="true"
                                [profile]="user.value.user_profile"
                                [avatarSize]="'medium'"
                                [profileLinkActive]="true" />
                              <span class="ms-2 fw-800">
                                {{ user.value.user_profile.first_name }}
                                {{ user.value.user_profile.last_name }}</span
                              >
                              <ng-container
                                *ngIf="
                                  !session.is_completed &&
                                  !hasEarnedCredits(user.value.user_id)
                                ">
                                <button
                                  aria-label="remove attendee button"
                                  class="btn btn-delete btn-sm"
                                  type="button"
                                  ngbTooltip="Remove Attendee"
                                  [autoClose]="'outside'"
                                  [ngbPopover]="popoverContent"
                                  [popoverTitle]="'Remove Attendee'"
                                  #p="ngbPopover"
                                  #t="ngbTooltip"
                                  [container]="'body'"
                                  (click)="t.close()">
                                  <i class="bi bi-x-circle-fill"></i>
                                </button>
                                <ng-template #popoverContent>
                                  <div>
                                    Are you sure you wish to remove this
                                    attendee?
                                  </div>
                                  <div class="app-hr-thin"></div>
                                  <div class="text-end mt-2">
                                    <button
                                      type="button"
                                      class="btn btn-secondary btn-sm px-3 m-1"
                                      (click)="p.close()">
                                      No
                                    </button>
                                    <button
                                      type="button"
                                      class="btn btn-primary btn-sm px-3 m-1"
                                      (click)="
                                        unregisterUser(
                                          sessionId,
                                          user.value.user_id
                                        );
                                        p.close()
                                      ">
                                      Yes
                                    </button>
                                  </div>
                                </ng-template>
                              </ng-container>
                            </div>
                          </td>
                          <td class="text-center">
                            <ng-container
                              *ngIf="
                                hasEarnedCredits(user.value.user_id);
                                else editable
                              ">
                              <input
                                class="form-check-input m-0"
                                type="checkbox"
                                [id]="
                                  'is-present-' +
                                  user.value.user_profile.user_id
                                "
                                [checked]="user.value.is_present"
                                disabled />
                            </ng-container>

                            <ng-template #editable>
                              <input
                                class="form-check-input m-0"
                                type="checkbox"
                                [id]="
                                  'is-present-' +
                                  user.value.user_profile.user_id
                                "
                                formControlName="is_present"
                                (change)="
                                  onPresentCheckboxChange(
                                    $event,
                                    user.value.user_profile.user_id
                                  )
                                " />
                            </ng-template>
                          </td>

                          <td style="width: 100px" *ngIf="session.quiz">
                            <div
                              class="d-flex align-items-center justify-content-center"
                              *ngIf="
                                getAttendeeQuizSubmission(
                                  user.value.user_id
                                ) as quizSubmission
                              ">
                              <button
                                (click)="
                                  openQuizSubmissionModal(user.value.user_id)
                                "
                                ngbTooltip="View Quiz Submission"
                                class="btn btn-link color-tertiary p-1">
                                <i class="bi bi-eye"></i>
                              </button>
                              <div
                                [ngClass]="{
                                  'text-success':
                                    quizSubmission.pass_or_fail === 'pass',
                                  'text-danger':
                                    quizSubmission.pass_or_fail === 'fail'
                                }">
                                <ng-container
                                  *ngIf="quizSubmission.grade !== null">
                                  {{ quizSubmission.grade }}%
                                </ng-container>
                              </div>
                            </div>
                          </td>
                          <td
                            class="text-center"
                            style="width: 100px"
                            *ngIf="session.survey">
                            <button
                              *ngIf="
                                getAttendeeSurveySubmission(user.value.user_id)
                              "
                              (click)="
                                openSurveySubmissionModal(user.value.user_id)
                              "
                              ngbTooltip="View Survey Submission"
                              class="btn btn-link color-tertiary p-1">
                              <i class="bi bi-eye"></i>
                            </button>
                          </td>
                          <td style="width: 40%">
                            <div class="d-flex align-items-center row mx-0">
                              <div
                                class="credit-form-container col"
                                [ngClass]="{
                                  'grey-border-right':
                                    session.credits &&
                                    session.credits.length > 0 &&
                                    user.value.is_present &&
                                    (session.credit_awarding_method !==
                                    PdCreditAwardingMethod.SESSION_COMPLETED
                                      ? true
                                      : session.is_completed),
                                }">
                                <ng-container
                                  *ngIf="
                                    user.value.is_present &&
                                      !hasEarnedCredits(user.value.user_id);
                                    else earnedCreditsTemplate
                                  "
                                  ><ng-container
                                    formArrayName="credits"
                                    *ngFor="
                                      let credit of getCreditsFor(i);
                                      let creditIndex = index
                                    ">
                                    <div
                                      [formGroupName]="creditIndex"
                                      class="mb-2">
                                      <div
                                        class="d-flex justify-content-between align-items-center mb-2">
                                        <div
                                          class="fw-800"
                                          style="flex-grow: 1">
                                          {{ credit.value.credit_type }}
                                        </div>
                                        <div class="text-danger fs-13 mx-3">
                                          <div
                                            *ngIf="credit.errors?.['required']">
                                            Required
                                          </div>
                                          <div
                                            *ngIf="credit.errors?.['maxValueExceeded']">
                                            Exceeds max limit
                                          </div>
                                        </div>
                                        <input
                                          type="number"
                                          min="0"
                                          [max]="credit.value.credit_max_value"
                                          class="form-control credit-input"
                                          formControlName="credit_value"
                                          [ngClass]="{
                                            'is-invalid': credit.invalid
                                          }" />
                                      </div>
                                    </div> </ng-container
                                ></ng-container>
                                <ng-template #earnedCreditsTemplate>
                                  <ng-container
                                    *ngFor="
                                      let earnedCredit of getEarnedCreditsForUser(
                                        user.value.user_id
                                      )
                                    ">
                                    <ng-container
                                      *ngFor="
                                        let credit of earnedCredit.credits
                                      ">
                                      <div
                                        class="d-flex align-items-center justify-content-between my-2"
                                        style="min-width: 110px">
                                        <div class="fw-800">
                                          {{ credit.credit_type }}
                                        </div>
                                        <div
                                          class="text-center pe-4"
                                          style="min-width: 10px">
                                          {{ credit.credit_value }}
                                        </div>
                                      </div>
                                    </ng-container>
                                  </ng-container>
                                </ng-template>
                              </div>
                              <div
                                class="px-3 col-4 credit-button-container"
                                style="width: 40%"
                                *ngIf="
                                  session.credits &&
                                  session.credits.length > 0 &&
                                  user.value.is_present &&
                                  (session.credit_awarding_method ===
                                  PdCreditAwardingMethod.SESSION_COMPLETED
                                    ? session.is_completed
                                    : true)
                                ">
                                <button
                                  type="button"
                                  [ngStyle]="{
                                    opacity: hasEarnedCredits(
                                      user.value.user_id
                                    )
                                      ? '0.65'
                                      : '1',
                                    'min-width': '130px'
                                  }"
                                  class="btn btn-primary fw-800 text-uppercase fs-14"
                                  (click)="
                                    hasEarnedCredits(user.value.user_id)
                                      ? unawardCreditsFromUser(
                                          user.value.user_id
                                        )
                                      : awardCreditsToUser(user.value.user_id)
                                  ">
                                  {{
                                    hasEarnedCredits(user.value.user_id)
                                      ? "Remove Credits"
                                      : "Award Credits"
                                  }}
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #attmessage>
                    <tr>
                      <td colspan="5">
                        <div class="no-content-message">
                          No attendees for this event
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
            <div class="add-att">
              <div class="label me-3 fw-600">+ Add Attendee:</div>
              <div class="att-select">
                <app-user-select
                  #attendeeSelect
                  [clearAfterSelection]="true"
                  [isMulti]="false"
                  [includeAllB2bDistricts]="true"
                  (selectedUser)="registerUser($event)" />
              </div>
            </div>
            <div
              *ngIf="
                usersCreditForm.value.users &&
                usersCreditForm.value.users.length > 0 &&
                !session.is_completed
              "
              class="complete text-center">
              <button
                class="btn btn-primary btn-largexx btn-complete fw-800"
                [ngbPopover]="sessionCompletePopover"
                #downloadCSVPopover="ngbPopover"
                [disabled]="usersCreditForm.invalid || formSubmitting">
                Complete Session
                {{
                  session.credit_awarding_method ===
                  PdCreditAwardingMethod.SESSION_COMPLETED
                    ? "and Award Credits"
                    : ""
                }}
              </button>
              <ng-template #sessionCompletePopover>
                <ng-container
                  *ngIf="
                    session.credit_awarding_method ===
                    PdCreditAwardingMethod.SESSION_COMPLETED
                  ">
                  Completing a session awards credits, certificates, and ends
                  the session.</ng-container
                >
                <p>Do you want to complete the session now?</p>
                <div class="text-end mt-2">
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm px-3 m-1"
                    (click)="downloadCSVPopover.close()">
                    No
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm px-3 m-1"
                    (click)="completeSession(); downloadCSVPopover.close()">
                    Yes
                  </button>
                </div>
              </ng-template>
            </div>
          </form>
        </ng-container>
      </ng-container>
      <ng-template #loadingTemplate>
        <div class="w-100" style="height: 400px">
          <app-loader />
        </div>
      </ng-template>
    </ng-container>
    <ng-template #deniedMessage>
      <div class="permission-denied">
        <app-permission-denied />
      </div>
    </ng-template>
  </div>
</div>
<app-proform-survey-modal
  *ngIf="session?.survey_proform_form_id"
  [formId]="session.survey_proform_form_id"
  [sessionId]="session.id"
  (formSubmitted)="onSurveySubmit($event)"
  #surveyModal />

<app-modal
  #quizSubmissionModal
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    options: { size: 'lg' },
    titleText: 'View Submission',
    showFooter: false
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="quizSubmissionModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div
    class="px-5 py-4"
    *ngIf="session && attendeeQuizSubmissionId && session.quiz_proform_form_id">
    <app-proforms-form
      [formId]="session.quiz_proform_form_id"
      [submissionId]="attendeeQuizSubmissionId"
      [viewState]="viewStates.GRADED" />
  </div>
</app-modal>

<app-modal
  #surveySubmissionModal
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    options: { size: 'lg' },
    titleText: 'View Submission',
    showFooter: false
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="surveySubmissionModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="px-5 py-4" *ngIf="session && attendeeSurveySubmissionId">
    <app-proforms-form
      [formId]="session.survey_proform_form_id"
      [submissionId]="attendeeSurveySubmissionId"
      [viewState]="viewStates.SUBMITTED" />
  </div>
</app-modal>

<app-modal
  #previewQuizModal
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    options: { size: 'lg' },
    titleText: 'Preview Form',
    showFooter: false
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="previewQuizModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="px-5 py-4" *ngIf="session && session.quiz_proform_form_id">
    <app-proforms-form [formId]="session.quiz_proform_form_id" />
  </div>
</app-modal>

<app-modal
  #quizResultsModal
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    options: { size: 'lg' },
    titleText: 'Quiz Results',
    showFooter: false
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="quizResultsModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div *ngIf="session && session.quiz_proform_form_id">
    <app-proforms-cumulative-quiz
      [proFormId]="session.quiz_proform_form_id"
      [sessionId]="sessionId" />
  </div>
</app-modal>
